"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Atoms = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const colorPalette_1 = require("./colorPalette");
const colorThemes_1 = require("./colorThemes");
const fontsSettings_1 = require("./fontsSettings");
const displayAndHeaderStyles_1 = require("./displayAndHeaderStyles");
const bodyStyles_1 = require("./bodyStyles");
const smallTextStyles_1 = require("./smallTextStyles");
const statStyles_1 = require("./statStyles");
const gridSettings_1 = require("./gridSettings");
const minTarget_1 = require("./minTarget");
const stateSettings_1 = require("./stateSettings");
const chartColors_1 = require("./chartColors");
const borderSettings_1 = require("./borderSettings");
const focusStates_1 = require("./focusStates");
const hotlinks_1 = require("./hotlinks");
const inputBackground_1 = require("./inputBackground");
const elevationSettings_1 = require("./elevationSettings");
const bevelSettings_1 = require("./bevelSettings");
const glowSettings_1 = require("./glowSettings");
const animationSettings_1 = require("./animationSettings");
const colorBlind_1 = require("./colorBlind");
const node_1 = require("../common/node");
const myMap_1 = require("../util/myMap");
/**
 * All atoms for each design system.
 * @category Atoms
 */
class Atoms extends node_1.Node {
    constructor(designSystem) {
        super("atoms", designSystem);
        this.atoms = new myMap_1.MyMap();
        this.designSystem = designSystem;
        this.colorPalette = new colorPalette_1.ColorPalette(this);
        this.colorThemes = new colorThemes_1.ColorThemes(this);
        this.fontsSettings = new fontsSettings_1.FontsSettings(this);
        this.displayAndHeaderStyles = new displayAndHeaderStyles_1.DisplayAndHeaderStyles(this);
        this.bodyStyles = new bodyStyles_1.BodyStyles(this);
        this.smallTextStyles = new smallTextStyles_1.SmallTextStyles(this);
        this.statStyles = new statStyles_1.StatStyles(this);
        this.gridSettings = new gridSettings_1.GridSettings(this);
        this.minimumTarget = new minTarget_1.MinimumTarget(this);
        this.stateSettings = new stateSettings_1.StateSettings(this);
        this.chartColors = new chartColors_1.ChartColors(this);
        this.borderSettings = new borderSettings_1.BorderSettings(this);
        this.focusStates = new focusStates_1.FocusStates(this);
        this.hotlinks = new hotlinks_1.Hotlinks(this);
        this.inputBackground = new inputBackground_1.InputBackground(this);
        this.elevationSettings = new elevationSettings_1.ElevationSettings(this);
        this.bevelSettings = new bevelSettings_1.BevelSettings(this);
        this.glowSettings = new glowSettings_1.GlowSettings(this);
        this.animationSettings = new animationSettings_1.AnimationSettings(this);
        this.colorBlind = new colorBlind_1.ColorBlind(this);
    }
    addAtom(atom) {
        this.atoms.set(atom.name, atom);
    }
    getAtom(key) {
        const atom = this.atoms.get(key);
        if (!atom) {
            throw new Error(`Atom '${key}' was not found`);
        }
        return atom;
    }
    serialize() {
        const obj = super.serialize();
        obj.colorPalette = this.colorPalette.serialize();
        obj.colorThemes = this.colorThemes.serialize();
        obj.fontsSettings = this.fontsSettings.serialize();
        obj.displayAndHeaderStyles = this.displayAndHeaderStyles.serialize();
        obj.bodyStyles = this.bodyStyles.serialize();
        obj.smallTextStyles = this.smallTextStyles.serialize();
        obj.statStyles = this.statStyles.serialize();
        obj.gridSettings = this.gridSettings.serialize();
        obj.minimumTarget = this.minimumTarget.serialize();
        obj.stateSettings = this.stateSettings.serialize();
        obj.chartColors = this.chartColors.serialize();
        obj.borderSettings = this.borderSettings.serialize();
        obj.focusStates = this.focusStates.serialize();
        obj.hotlinks = this.hotlinks.serialize();
        obj.inputBackground = this.inputBackground.serialize();
        obj.elevationSettings = this.elevationSettings.serialize();
        obj.bevelSettings = this.bevelSettings.serialize();
        obj.glowSettings = this.glowSettings.serialize();
        obj.animationSettings = this.animationSettings.serialize();
        obj.colorBlind = this.colorBlind.serialize();
        return obj;
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.colorPalette.deserialize(obj.colorPalette);
        this.colorThemes.deserialize(obj.colorThemes);
        this.fontsSettings.deserialize(obj.fontsSettings);
        this.displayAndHeaderStyles.deserialize(obj.displayAndHeaderStyles);
        this.bodyStyles.deserialize(obj.bodyStyles);
        this.smallTextStyles.deserialize(obj.smallTextStyles);
        this.statStyles.deserialize(obj.statStyles);
        this.gridSettings.deserialize(obj.gridSettings);
        this.minimumTarget.deserialize(obj.minimumTarget);
        this.stateSettings.deserialize(obj.stateSettings);
        this.chartColors.deserialize(obj.chartColors);
        this.borderSettings.deserialize(obj.borderSettings);
        this.focusStates.deserialize(obj.focusStates);
        this.hotlinks.deserialize(obj.hotlinks);
        this.inputBackground.deserialize(obj.inputBackground);
        this.elevationSettings.deserialize(obj.elevationSettings);
        this.bevelSettings.deserialize(obj.bevelSettings);
        this.glowSettings.deserialize(obj.glowSettings);
        this.animationSettings.deserialize(obj.animationSettings);
        this.colorBlind.deserialize(obj.colorBlind);
    }
}
exports.Atoms = Atoms;
